import { useEffect } from "react";

import { RefundCalculationWidget } from "@/widgets/refund/RefundCalculationWidget";

export const RefundCalculationPage = () => {
  useEffect(() => {
    document.title = "Буцаалтын тооцоолол";
  }, []);

  return (
    <div className="page">
      <RefundCalculationWidget />
    </div>
  );
};
